// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__Y_SdV","social_icon":"styles_social_icon__cCCI7","image":"styles_image__g7S3J","subcard":"styles_subcard__6gVOx","body":"styles_body__TQ2tX"};